import { IRateResSchema } from '@monetize/types/app';
import { useState } from 'react';
import { MdInfo } from 'react-icons/md';
import {
  MFlex,
  MIcon,
  MText,
  MTooltip,
} from '../../../../../components/Monetize';
import QuoteOfferingRateRightEl from './QuoteOfferingRateRightEl';

const RateItem = ({
  title,
  item,
  isSubtitle,
  isSelected,
  isHighlight,
  isDisabled,
}: {
  title: string;
  item: IRateResSchema;
  isSubtitle: boolean;
  isSelected: boolean;
  isHighlight: boolean;
  isDisabled: boolean;
}) => {
  /**
   *  using _groupHover seems to be not working as expected. It was showing the
   *  tooltip even when we hover the dropdown box. To avoid this we are using state
   *  to track the row hover state and open the tooltip based on that, so hovering
   *  anywhere on the rate row reveals the internal description.
   */
  const [isRowHovered, setIsRowHovered] = useState<boolean>(false);

  return (
    <MFlex
      alignItems="center"
      justifyContent="space-between"
      w="100%"
      onMouseEnter={() => {
        setIsRowHovered(true);
      }}
      onMouseLeave={() => {
        setIsRowHovered(false);
      }}
    >
      <MFlex alignItems="center">
        <QuoteOfferingRateRightEl rate={item} />
        <MText
          color="inherit"
          fontSize={isSubtitle ? '12px' : 'sm'}
          mb="-2px"
          mt="0px"
          ml="2"
          maxW="50vw"
        >
          {title}
        </MText>
      </MFlex>
      {/* Tooltip only displays if there is an internal rate, but space is reserved so the menu does not change sizes */}
      {item?.internalDescription && (
        <MTooltip
          label={
            item.internalDescription?.includes('\n') ? (
              <>
                {item.internalDescription.split('\n').map((row, i) => (
                  <div key={i}>{row}</div>
                ))}
              </>
            ) : (
              item.internalDescription
            )
          }
          placement="bottom-start"
          isOpen={isRowHovered}
        >
          <MFlex ml="2" alignItems="center" minWidth={4}>
            <MIcon
              as={MdInfo}
              display="flex"
              color="tPurple.base"
              className="info"
            />
          </MFlex>
        </MTooltip>
      )}
    </MFlex>
  );
};
export const RateItemContent = ({
  title,
  item,
  isSubtitle,
  isSelected,
  isHighlight,
  isDisabled,
}: {
  title: string;
  item: IRateResSchema;
  isSubtitle: boolean;
  isSelected: boolean;
  isHighlight: boolean;
  isDisabled: boolean;
}) => (
  <RateItem
    title={title}
    item={item}
    isSubtitle={isSubtitle}
    isSelected={isSelected}
    isHighlight={isHighlight}
    isDisabled={isDisabled}
  />
);
